const { getSize } = require('../modules/element-state');

/**
 * LineFlatHeight
 * @class
 */
class LineFlatHeight {

  /**
   * @static
   * @return {object} default options
   */
  static get defOpts() {
    return {
      itemSelector: 'section',
    }
  }

  /**
   * @instance
   * @param el {string|HTMLElement} element
   * @param opts {object} options
   */
  constructor(el, opts = {}) {
    const { itemSelector } = _.defaults(opts, LineFlatHeight.defOpts);

    this.el = el;
    this.itemSelector = itemSelector;

    window.addEventListener('load', this.onWindowLoaded.bind(this), false);
    window.addEventListener('resize', this.onResized.bind(this), false);
  }

  /**
   * @instance
   * @private
   */
  onWindowLoaded() {
    this.flatten(this.group);
  }

  /**
   * @instance
   * @private
   */
  onResized() {
    this.flatten(this.group);
  }

  /**
   * @instance
   * @private
   */
  get group() {
    const itemElms = this.el.querySelectorAll(this.itemSelector);
    this.setHeight('1px');
    const group = _.map(_.groupBy(itemElms, (el) => {
      return el.getBoundingClientRect().top;
    }), (val) => val );
    this.setHeight(null);
    return group;
  }

  /**
   * @instance
   * @private
   * @param num {number|null}
   */
  setHeight(num) {
    const itemElms = this.el.querySelectorAll(this.itemSelector);
    _.forEach(itemElms, (el) => {
      el.style.height = num;
    });
  }

  /**
   * @instance
   * @private
   * @param elms {HTMLElement}
   */
  flatten(elms) {
    elms.forEach( (_elms) => {
      if(1 >= _elms.length) return;
      const h = this.getHeight(_elms);
      _.forEach(_elms, (el) => {
        el.style.height = `${h}px`;
      });
    });
  }

  /**
   * @instance
   * @private
   * @param elms {HTMLElement}
   */
  getHeight(elms) {
    let h = 0;
    _.forEach(elms, (el) => {
      const _h = getSize(el).h;
      if(h < _h) h = _h;
    });
    return h;
  }

}

/**
 * class exports
 */
module.exports = LineFlatHeight;



/** WEBPACK FOOTER **
 ** ./webpack/requires/view/ui/line-flat-height.js
 **/